
import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     
     GET_INDICADOR_DESEMPENO_ENLACES: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"sistema_municipios/"+data.idmunicipio+"/indicador_desempeno/" ,
          responseType: 'json', 
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },








    CREAR_INDICADOR_DESEMPENO_ENLACES: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"indicador_desempeno/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
          
           idmunicipio:data.idmunicipio,
           idclasificacion:data.idclasificacion,
           clave:data.clave,
           nombre:data.nombre, 
           objetivo_indicador:data.objetivo_indicador, 
           interpretacion:data.interpretacion,
           //idvariables:data.idvariables,
           variables_agregadas:data.variables_agregadas, 
           formula:data.formula, 
           unidad_medida_resultado:data.unidad_medida_resultado,
           idfrecuencia:data.idfrecuencia,
           idsecretaria:data.idsecretaria, 
           iddepartamento:data.iddepartamento, 
           valor_min:data.valor_min,
           valor_max:data.valor_max,
           meta:data.meta, 
         
         
               
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },





    EDITAR_INDICADOR_DESEMPENO_ENLACES: async function(data) {




      
      var result =  await axios
        ({
          method: 'PUT',
          url: this.$store.state.baseapi+"indicador_desempeno/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
            
           idmunicipio:data.idmunicipio,
           idclasificacion:data.idclasificacion,
           'clave':data.clave,
           'nombre':data.nombre, 
           'objetivo_indicador':data.objetivo_indicador, 
           'interpretacion':data.interpretacion,
           //idvariables:data.idvariables,
           'variables_agregadas':data.variables_agregadas, 
           'formula':data.formula, 
           'unidad_medida_resultado':data.unidad_medida_resultado,
           idfrecuencia:data.idfrecuencia,
           idsecretaria:data.idsecretaria, 
           iddepartamento:data.iddepartamento, 
           'valor_min':data.valor_min,
           'valor_max':data.valor_max,
           'meta':data.meta, 
         
         
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },

    ELIMINAR_INDICADOR_DESEMPENO_ENLACES: async function(data) {




      
      var result =  await axios
        ({
          method: 'delete',
          url: this.$store.state.baseapi+"indicador_desempeno/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
    },
  }